<db-dialog-wrapper [dialog]="this" [hasCloseButton]="true" [canClose]="true"
                   [width]="!!isMobile ? '100%' : '488px'" [fullScreen]="!!isMobile">
  <div class="add-tag-dialog" [formGroup]="addTagForm">
    <h1 class="add-tag-dialog__title">
      <span class="db-icon db-icon-ds-arrow add-tag-dialog__back-button" *ngIf="!hideBackButton"
            (click)="backToList()"></span>
      <span>{{'text_addTagTitle' | dbText}}</span>
    </h1>

    <div class="add-tag-dialog__form ds-input-wrap" [ngClass]="{'mb20': serverErrors}">
      <div>
        <input type="text" class="ds-input" formControlName="tagTitle"
               [placeholder]="'text_addTagPlaceholder' | dbText" [ngClass]="{'error': serverErrors}">
        <a class="ds-btn-blue" [ngClass]="{'ds-btn-disabled': loading}" (click)="addTag()">
          <span *ngIf="!loading">{{'text_addTagBtn' | dbText}}</span>
          <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
        </a>
      </div>
      <span class="ds-input-error-msg" *ngIf="serverErrors">{{ serverErrors }}</span>
    </div>
  </div>
</db-dialog-wrapper>
